import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Leaf, Star, CheckCircle, Thermometer, Droplet, Coffee, Flame, Cookie } from 'lucide-react';

// Import local images
import newCupImage from '../assets/images/new_cup.jpg';
import cup220Image from '../assets/images/cup220_1.jpg';

const EdibleCupsCategory = () => {
  // Product data for the two cups - separate pages
  const products = [
    {
      id: 'cup-110ml',
      name: 'Cupffee Edible CUP | 110 ml',
      cartonPrice: 8,
      cupsPerCarton: 10,
      stock: 'In Stock',
      image: newCupImage,
      description: 'Perfect for espresso and small beverages',
      link: '/edible-cup-110'
    },
    {
      id: 'cup-220ml',
      name: 'Cupffee Edible CUP | 220 ml',
      cartonPrice: 12,
      cupsPerCarton: 12,
      stock: 'In Stock',
      image: cup220Image,
      description: 'Ideal for coffee, tea and medium drinks',
      link: '/edible-cup-220'
    }
  ];

  return (
    <div className="category-page edible-cups-category">
      {/* Centered Header */}
      <section className="edible-cups-hero">
        <div className="container">
          <h1 className="edible-cups-title">Cupffee Edible Cups</h1>
          <p className="edible-cups-subtitle">
            Discover our range of 100% edible, eco-friendly cups. Made from natural ingredients, 
            perfect for hot and cold beverages.
          </p>
        </div>
      </section>

      {/* Product Images Section */}
      <section className="edible-cups-products">
        <div className="container">
          <div className="edible-cups-grid">
            {products.map(product => (
              <Link to={product.link} key={product.id} className="edible-cup-item">
                <div className="edible-cup-image-wrapper">
                  <img src={product.image} alt={product.name} />
                  <div className="edible-cup-overlay">
                    <span className="view-product-btn">
                      View Product <ArrowRight size={18} />
                    </span>
                  </div>
                </div>
                <div className="edible-cup-info">
                  <h3>{product.name}</h3>
                  <p>{product.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Informational Section - Text Boxes */}
      <section className="category-info-section">
        <div className="container">
          <div className="cupffee-text-boxes">
            {/* Row 1 */}
            <div className="text-boxes-row">
              <div className="info-text-box">
                <div className="text-box-icon">
                  <Leaf size={28} />
                </div>
                <h4>100% vegan</h4>
                <p>Handpicked for purity: only the best plant-based ingredients, including natural grains and coconut oil.</p>
              </div>
              <div className="info-text-box">
                <div className="text-box-icon">
                  <Cookie size={28} />
                </div>
                <h4>Crunchy and delicious</h4>
                <p>The sustainable alternative to disposable cups – a tasty solution to plastic pollution!</p>
              </div>
            </div>
            
            {/* Row 2 */}
            <div className="text-boxes-row">
              <div className="info-text-box">
                <div className="text-box-icon">
                  <CheckCircle size={28} />
                </div>
                <h4>GMO free</h4>
                <p>Just nature's best 100% GMO-free no artificial colorants, sweeteners or preservatives</p>
              </div>
              <div className="info-text-box">
                <div className="text-box-icon">
                  <Star size={28} />
                </div>
                <h4>Completely natural</h4>
                <p>Masterfully crafted from 7 sustainable, locally sourced ingredients of natural origin.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section with Feature Boxes */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="section-title">Why Choose Our Edible Cup?</h2>
          
          <div className="features-layout">
            {/* Row 1 */}
            <div className="features-row">
              <div className="feature-box">
                <div className="feature-icon"><Thermometer size={40} /></div>
                <h3>Thermo Resistant</h3>
                <p>Cupffee resists high temps up to 85°C, making sure your hot drink stays contained.</p>
              </div>
              <div className="feature-box">
                <div className="feature-icon"><Droplet size={40} /></div>
                <h3>Leak-Proof</h3>
                <p>Thanks to our unique recipe, Cupffee cups won't leak for hours. No leaks, no worries!</p>
              </div>
            </div>

            {/* Row 2 (centered single) */}
            <div className="features-row center-row">
              <div className="feature-box">
                <div className="feature-icon"><Coffee size={40} /></div>
                <h3>No Taste Change</h3>
                <p>Not a fan of sugar? Cupffee won't change the taste of your coffee or tea.</p>
              </div>
            </div>

            {/* Row 3 */}
            <div className="features-row">
              <div className="feature-box">
                <div className="feature-icon"><Flame size={40} /></div>
                <h3>Low Calorie</h3>
                <p>Grab your coffee in a Cupffee for a guilt-free indulgence. Sip and snack away!</p>
              </div>
              <div className="feature-box">
                <div className="feature-icon"><Cookie size={40} /></div>
                <h3>Crunchy</h3>
                <p>Tasty as a cookie, Cupffee will be crunchy from the first sip till the last bite.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EdibleCupsCategory;
